var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeleteTrash = function SvgDeleteTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "current",
    height: "current",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.08 3.83h-3.96v-.94c0-.57-.47-1.04-1.04-1.04H7.92c-.57 0-1.04.47-1.04 1.04v.94H2.92c-.35 0-.62.28-.62.62s.28.62.62.62h.62v11.99c0 .59.48 1.08 1.07 1.08h10.77c.59 0 1.07-.48 1.07-1.08V5.08h.62c.35 0 .62-.28.62-.62s-.28-.62-.62-.62ZM8.12 3.1h3.75v.73H8.12V3.1Zm7.08 13.8H4.79V5.08h10.42V16.9ZM7.47 9.43c-.24-.24-.24-.64 0-.88s.64-.24.88 0l1.64 1.64 1.64-1.64c.24-.24.64-.24.88 0s.24.64 0 .88l-1.64 1.64 1.64 1.64c.24.24.24.64 0 .88-.12.12-.28.18-.44.18s-.32-.06-.44-.18l-1.64-1.64-1.64 1.64c-.12.12-.28.18-.44.18s-.32-.06-.44-.18a.628.628 0 0 1 0-.88l1.64-1.64-1.64-1.64Z",
    fill: "current"
  })));
};
export default SvgDeleteTrash;